import { createContext } from "react";

export type RiskItem = {
  key: string;
  value: string;
  color: string;
  backgroundColor: string;
  priority: number;
};

export type CoverageStatusItem = {
  label: string;
  color: string;
  priority: number;
};

type SuccessPlanContextProps = {
  dispatch: React.Dispatch<any>;
  riskItems: RiskItem[];
  coverageStatusItems: CoverageStatusItem[];
};

const SuccessPlanContext = createContext<SuccessPlanContextProps>({
  dispatch: () => {},
  riskItems: [],
  coverageStatusItems: [],
});

export default SuccessPlanContext;
